var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-save"},[(!_vm.updating)?_c('button',{staticClass:"do-not-print-me",attrs:{"disabled":_vm.disabled}},[_vm._t("default",[_vm._v("Save")])],2):_c('LoadingButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }